export default __webpack_public_path__ + "dist/media/PlusWhite.35e798fe.svg";